import { useState, useRef, useEffect } from "react";
import { api } from "../lib/api";

export function CollegeSearch({ value, onChange, courseType, placeholder, testId }) {
  const [query, setQuery] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);
  const debounceRef = useRef(null);

  const [noMatch, setNoMatch] = useState(false);

  useEffect(() => { setQuery(value || ""); }, [value]);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const search = (q) => {
    setQuery(q);
    onChange(q);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (q.length < 2) { setResults([]); setOpen(false); setNoMatch(false); return; }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams({ q, limit: "15" });
        if (courseType) params.set("course_type", courseType);
        const { data } = await api.get(`/reference/nmc-colleges?${params}`);
        setResults(data);
        setOpen(data.length > 0);
        setNoMatch(data.length === 0);
      } catch { setResults([]); setNoMatch(true); }
      setLoading(false);
    }, 250);
  };

  const pick = (college) => {
    setQuery(college.college);
    onChange(college.college);
    setOpen(false);
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <input
        className="form-input"
        placeholder={placeholder || "Type to search NMC colleges..."}
        value={query}
        onChange={(e) => search(e.target.value)}
        onFocus={() => { if (results.length) setOpen(true); }}
        data-testid={testId}
        autoComplete="off"
      />
      {loading && <div className="form-hint" style={{ color: "var(--text-2)" }}>Searching...</div>}
      {!loading && noMatch && <div className="form-hint" style={{ color: "var(--text-2)" }}>No NMC colleges match &ldquo;{query}&rdquo; — you can type a custom name</div>}
      {open && results.length > 0 && (
        <ul
          style={{
            position: "absolute", zIndex: 50, top: "100%", left: 0, right: 0,
            background: "var(--bg)", border: "1px solid var(--border)", borderRadius: 8,
            maxHeight: 220, overflowY: "auto", margin: 0, padding: 0, listStyle: "none",
            boxShadow: "0 8px 24px rgba(0,0,0,.12)",
          }}
          data-testid={testId ? `${testId}-dropdown` : undefined}
        >
          {results.map((r, i) => (
            <li
              key={`${r.college}-${r.course_type}-${i}`}
              onClick={() => pick(r)}
              style={{
                padding: "8px 12px", cursor: "pointer", fontSize: 13,
                borderBottom: i < results.length - 1 ? "1px solid var(--border)" : "none",
              }}
              onMouseEnter={(e) => (e.target.style.background = "var(--bg-alt)")}
              onMouseLeave={(e) => (e.target.style.background = "transparent")}
            >
              <div style={{ fontWeight: 500 }}>{r.college}</div>
              <div style={{ fontSize: 11, color: "var(--text-2)", marginTop: 2 }}>
                {r.state} · {r.university}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
